<template>
  <div>
    <el-row style="margin-top: 20px">
      <el-col :span="6">
        <span>应付金额：元</span>
      </el-col>
      <el-col :span="6">
        <span>调整金额：元</span>
      </el-col>
      <el-col :span="6">
        <span>实付金额：元</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-divider content-position="left">结算调整明细</el-divider>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column label="类别" prop="reason"></el-table-column>
          <el-table-column label="原因" prop="reason"></el-table-column>
          <el-table-column label="金额" prop="money"></el-table-column>
          <el-table-column label="调整凭证">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openVoucher(scope.row)">查看凭证</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog title="调整凭证" center :visible.sync="adjustFormVisible" width="600px">
          <el-form :model="adjustForm" ref="adjustForm" label-width="100px">
            <el-image :src="src"></el-image>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [
        {
          ID: 1,
          reason: '罚款',
          money: -300,
          img: '',
        },
        {
          ID: 2,
          reason: '折扣',
          money: -200,
          img: '',
        },
      ],
      adjustForm: {},
      adjustFormVisible: false,
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
    };
  },
  methods: {
    queryTable() {
    },
    openVoucher(row) {
      this.adjustFormVisible = true;
    },
    close() {
      this.adjustFormVisible = false;
    },
  },
  created() {
    this.queryTable();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financeCenter/tcBillingDetails.vue